<template>
<div class="more-component">
  <section class="more-component__section">
    <h4 class="more-component__section-header">Профиль</h4>
    <ul class="more-component__section-items">
      <li
        v-if="!hasUser"
        class="more-component__section-item"
      >
        <button
          @click="$store.commit('ui/toggleAuthModal')"
          class="more-component__section-item-content"
        >
          <span>Вход</span>
        </button>
      </li>
      <template v-else>
        <li class="more-component__section-item">
          <router-link
            :to="{ name: 'dashboard' }"
            class="more-component__section-item-content"
          >
            <span>Личный кабинет</span>
          </router-link>
        </li>
        <li class="more-component__section-item">
          <router-link
            :to="{ name: 'orders' }"
            class="more-component__section-item-content"
          >
            <span>Мои заказы</span>
          </router-link>
        </li>
        <li v-if="!!referralProgram" class="more-component__section-item">
          <a :href="referralProgram.invite_url" target="_blank" class="more-component__section-item-content">
            <span>Пригласить друзей</span>
          </a>
        </li>
        <li class="more-component__section-item">
          <router-link
            :to="{ name: 'addresses.list' }"
            class="more-component__section-item-content"
          >
            <span>Мои адреса</span>
          </router-link>
        </li>
        <li class="more-component__section-item">
          <button
            @click="$store.dispatch('auth/logout')"
            class="more-component__section-item-content"
          >
            <span>Выход</span>
          </button>
        </li>
      </template>
    </ul>
  </section>
  <section class="more-component__section">
    <h4 class="more-component__section-header">Информация</h4>
    <ul class="more-component__section-items">
      <li
        v-for="mainMenuLink in mainMenuLinks"
        class="more-component__section-item"
      >
        <router-link
          :to="mainMenuLink.to"
          class="more-component__section-item-content"
        >
          <span>{{ mainMenuLink.text }}</span>
        </router-link>
      </li>
      <li v-if="legalDocs.privacy_policy" class="more-component__section-item">
        <router-link :to="{ name: 'legal-privacy-policy' }" class="more-component__section-item-content">
          <span>Политика конфиденциальности</span>
        </router-link>
      </li>
      <li v-if="legalDocs.personal_data" class="more-component__section-item">
        <router-link :to="{ name: 'legal-personal-data-policy' }" class="more-component__section-item-content">
          <span>Обработка персональных данных</span>
        </router-link>
      </li>
      <li v-if="legalDocs.personal_data_agreement" class="more-component__section-item">
        <router-link :to="{ name: 'legal-personal-data-agreement' }" class="more-component__section-item-content">
          <span>Согласие на обработку персональных данных</span>
        </router-link>
      </li>
      <li v-if="legalDocs.eula" class="more-component__section-item">
        <router-link :to="{ name: 'legal-eula' }" class="more-component__section-item-content">
          <span>Пользовательское соглашение</span>
        </router-link>
      </li>
      <li v-if="legalDocs.terms" class="more-component__section-item">
        <router-link :to="{ name: 'legal-terms' }" class="more-component__section-item-content">
          <span>Публичная оферта</span>
        </router-link>
      </li>
    </ul>
  </section>
</div>
</template>

<script>
import InjectsSeo from '@/mixins/InjectsSeo'
import HasMainMenuLinks from "@/mixins/HasMainMenuLinks"
import { mapGetters } from 'vuex'

export default {
  mixins: [InjectsSeo, HasMainMenuLinks],

  metaInfo() {
    return {
      title: this.getFullPageTitle('Дополнительная информация'),
    }
  },

  computed: {
    ...mapGetters({
      hasUser: 'auth/hasUser',
      referralProgram: 'auth/referralProgram',
      legalDocs: 'settings/legalDocs',
    }),
  },
}
</script>

<style lang="less">
@r: more-component;
.@{r} {
  @apply bg-grey-lightest px-4;
  &__section {

  }
  &__section-header {
    @apply text-lg font-semibold my-3 px-1;
  }
  &__section-items {
    @apply bg-white rounded-lg shadow-lg my-3 py-2 px-4;
  }
  &__section-item {
    @apply flex;
    & ~ & {
      @apply border-t border-grey-lighter;
    }
  }
  &__section-item-content {
    @apply flex-grow py-3 text-dark;
    button& {
      @apply text-left;
    }
  }
}
</style>
